import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchHistoryList } from "../../apis/clienHistory";

export const fetchHistoryListData = createAsyncThunk(
  "historylList/fetchHistoryList",
  async (jobId: string, { rejectWithValue }) => {
    try {
      const historyList = await fetchHistoryList(jobId);
      return historyList;
    } catch (error: any) {
      console.log("error->", error);
      return rejectWithValue(error.message);
    }
  }
);
